<template>
  <div id="app" :class="{ 'scroll-y': isIndex }">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      isIndex: false,
    };
  },
  updated() {
    if (this.$route.path.indexOf("Index") == 1) {
      this.isIndex = true;
    } else {
      this.isIndex = false;
    }
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.scroll-y {
  overflow-y: hidden;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
